import { Record } from 'immutable';

const OperationRecord = Record({
	operation: null,
	targetType: null,
});
export default OperationRecord;
